import React, { useState, useEffect } from "react";
import { placeholderImage, imageFallback } from "./config";
import "../styles/CoursePage.css";
import { useNavigate, useLocation } from "react-router-dom";
import { FaArrowLeft, FaBook, FaVideo, FaFileAlt, FaFilePowerpoint, FaChevronRight, FaPlay, FaSearch } from "react-icons/fa";

const CoursePage = () => {
  console.log("🚀 CoursePage Component Mounted!");
  
  const navigate = useNavigate();
  const location = useLocation();
  
  console.log("📍 Current Location:", location.pathname);
  console.log("📍 Location State:", location.state);
  
  // Get category from URL params or location state
  const params = new URLSearchParams(window.location.search);
  const categoryFromUrl = params.get('category');
  const categoryFromState = location.state?.filterCategory;
  
  console.log("📍 Category from URL:", categoryFromUrl);
  console.log("📍 Category from State:", categoryFromState);
  
  // States
  const [courses, setCourses] = useState({});
  const [allCourses, setAllCourses] = useState([]); // Store raw API data
  const [topics, setTopics] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [topicDetails, setTopicDetails] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [view, setView] = useState("courses"); // courses, topics, content
  const [contentFilter, setContentFilter] = useState("All"); // All, Notes, Books, Videos, Presentations
  const [categoryFilter, setCategoryFilter] = useState(categoryFromUrl || categoryFromState || null); // Category filter from CourseCard
  
  // User data from localStorage (mentor login data) - OPTIONAL
  const userData = JSON.parse(localStorage.getItem("userData")) || { id: 96, reg_id: 5 }; // Default demo user
  const mentorId = userData?.id || 96; // Default mentor ID
  const regId = userData?.reg_id || 5; // Default reg ID
  
  console.log("User Data from localStorage:", userData);
  console.log("Mentor ID:", mentorId);
  console.log("Reg ID:", regId);
  console.log("Category Filter:", categoryFilter);

  // API Base URL
  const API_BASE = "https://k12.easylearn.org.in/Easylearn";

  // ✅ AUTHENTICATION CHECK REMOVED - No login required

  // Fetch courses on component mount
  useEffect(() => {
    if (userData && userData.id) {
      console.log("✅ useEffect triggered - Fetching courses...");
      fetchCourses();
    }
  }, []); // Empty dependency array - run only once on mount

  // Update category filter when location state or URL params change
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const categoryFromUrl = params.get('category');
    const categoryFromState = location.state?.filterCategory;
    
    const newCategory = categoryFromUrl || categoryFromState;
    
    if (newCategory && newCategory !== categoryFilter) {
      setCategoryFilter(newCategory);
      console.log("Updated category filter to:", newCategory);
    }
  }, [location.state, location.search]);

  // Filter and group courses whenever categoryFilter or allCourses changes
  useEffect(() => {
    if (allCourses.length > 0) {
      filterAndGroupCourses();
    }
  }, [categoryFilter, allCourses]);

  // If no userData, show loading/redirect message
  if (!userData || !userData.id) {
    return (
      <div className="course-page">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Redirecting to login...</p>
        </div>
      </div>
    );
  }

  // Fetch Courses
  const fetchCourses = async () => {
    setLoading(true);
    console.log("=== FETCHING COURSES ===");
    console.log("Mentor ID:", mentorId);
    console.log("API URL:", `${API_BASE}/Course_Controller/mentorcourse_details_getdata`);
    
    try {
      const formData = new URLSearchParams();
      formData.append('id', mentorId);
      
      console.log("Form Data:", formData.toString());
      
      const response = await fetch(
        `${API_BASE}/Course_Controller/mentorcourse_details_getdata`,
        {
          method: "POST",
          headers: { 
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: formData,
        }
      );
      
      console.log("Response Status:", response.status);
      console.log("Response OK:", response.ok);
      
      // Get response as text first to see raw data
      const textData = await response.text();
      console.log("Raw Response Text:", textData);
      
      // Try to parse as JSON
      let result;
      try {
        result = JSON.parse(textData);
        console.log("Parsed JSON:", result);
      } catch (parseError) {
        console.error("JSON Parse Error:", parseError);
        console.error("Could not parse response as JSON");
        setLoading(false);
        return;
      }
      
      console.log("Response.Response:", result.Response);
      console.log("Response.data type:", typeof result.data);
      console.log("Response.data:", result.data);
      
      if (result.Response === "OK" && result.data !== "No Data Found") {
        // Check if data is array
        if (!Array.isArray(result.data)) {
          console.error("Data is not an array!");
          console.error("Data type:", typeof result.data);
          console.error("Data value:", result.data);
          setLoading(false);
          return;
        }
        
        console.log("✅ Total courses:", result.data.length);
        
        // Log all partner names for debugging
        const partnerNames = [...new Set(result.data.map(c => c.partner_name))];
        console.log("🔍 All Partner Names from API:", partnerNames);
        
        // Store raw course data
        setAllCourses(result.data);
        
        // Initial grouping will be done by useEffect
        setLoading(false);
      } else {
        console.log("❌ No courses found or invalid response");
        console.log("Response data:", result.data);
        setLoading(false);
      }
    } catch (error) {
      console.error("=== ❌ ERROR FETCHING COURSES ===");
      console.error("Error:", error);
      console.error("Error message:", error.message);
      console.error("Error stack:", error.stack);
      setLoading(false);
    }
    console.log("=== ✅ FETCH COMPLETE ===");
  };

  // Filter and group courses based on category
  const filterAndGroupCourses = () => {
    console.log("=== FILTERING COURSES ===");
    console.log("Category Filter:", categoryFilter);
    console.log("Total Courses:", allCourses.length);
    
    let filteredCourses = allCourses;
    
    // Category-specific filtering
    if (categoryFilter === "K12") {
      console.log("K12 selected - showing aarshi and idream courses");
      // Show courses from aarshi and idream partners
      filteredCourses = allCourses.filter(course => {
        const partner = (course.partner_name || '').toLowerCase();
        return partner.includes('aarshi') || partner.includes('idream');
      });
    } 
    else if (categoryFilter === "Vocational") {
      console.log("Vocational selected - filtering vocational courses");
      // Filter courses that have vocational-related partner names
      filteredCourses = allCourses.filter(course => {
        const partner = (course.partner_name || '').toLowerCase();
        const courseName = (course.course_name || '').toLowerCase();
        // Check if partner or course name contains vocational keywords
        return partner.includes('vocational') || 
               partner.includes('skill') || 
               partner.includes('career') ||
               courseName.includes('vocational') ||
               courseName.includes('skill');
      });
    }
    // For other specific filters
    else if (categoryFilter) {
      const normalizedFilter = categoryFilter.toLowerCase().replace(/[-\s]/g, '');
      console.log("Normalized Filter:", normalizedFilter);
      
      filteredCourses = allCourses.filter(course => {
        const normalizedPartner = (course.partner_name || '').toLowerCase().replace(/[-\s]/g, '');
        const matches = normalizedPartner.includes(normalizedFilter);
        
        if (matches) {
          console.log(`✅ MATCH: ${course.course_name} (Partner: ${course.partner_name})`);
        }
        
        return matches;
      });
      
      console.log(`Filtered to ${filteredCourses.length} courses`);
    }
    
    // Group filtered courses by partner_name
    const groupedCourses = filteredCourses.reduce((acc, course) => {
      const partner = course.partner_name || "Unknown";
      
      if (!acc[partner]) {
        acc[partner] = [];
      }
      acc[partner].push(course);
      return acc;
    }, {});
    
    console.log("✅ Grouped Courses:", Object.keys(groupedCourses));
    console.log("✅ Total Partner Groups:", Object.keys(groupedCourses).length);
    console.log("✅ Total Courses Found:", filteredCourses.length);
    
    setCourses(groupedCourses);
  };

  // Fetch Topics for a course
  const fetchTopics = async (courseId) => {
    setLoading(true);
    console.log("=== FETCHING TOPICS ===");
    console.log("Course ID:", courseId);
    
    try {
      const response = await fetch(
        `${API_BASE}/Course_Controller/get_topics_list`,
        {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: new URLSearchParams({ course_id: courseId }),
        }
      );
      
      console.log("Topics Response Status:", response.status);
      
      const result = await response.json();
      console.log("Full Topics Response:", result);
      
      if (result.Response === "OK" && result.data && result.data !== "FALSE" && result.data !== "No Data Found") {
        let topicsData;
        
        if (result.data.success && Array.isArray(result.data.data)) {
          topicsData = result.data.data;
        } else if (Array.isArray(result.data)) {
          topicsData = result.data;
        } else if (typeof result.data === 'object' && result.data !== null) {
          const dataKeys = Object.keys(result.data);
          const arrayKey = dataKeys.find(key => Array.isArray(result.data[key]));
          if (arrayKey) {
            topicsData = result.data[arrayKey];
          } else {
            topicsData = Object.values(result.data);
          }
        } else {
          topicsData = [result.data];
        }
        
        console.log("✅ Topics loaded:", topicsData.length);
        setTopics(topicsData);
        setView("topics");
        setLoading(false);
      } else {
        console.log("❌ No topics found");
        setLoading(false);
      }
    } catch (error) {
      console.error("❌ ERROR FETCHING TOPICS:", error);
      setLoading(false);
    }
  };

  // Fetch Content for a topic
  const fetchTopicContent = async (topicId) => {
    setLoading(true);
    console.log("=== FETCHING TOPIC CONTENT ===");
    console.log("Topic ID:", topicId);
    
    const endpoint = `${API_BASE}/Course_Controller/get_topic_by_id`;
    console.log("API URL:", endpoint);
    
    try {
      const formData = new URLSearchParams();
      formData.append('id', topicId); // Using 'id' instead of 'unique_id'
      
      console.log("Request Body:", formData.toString());
      
      const response = await fetch(endpoint, {
        method: "POST",
        headers: { 
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: formData,
      });
      
      console.log("Response Status:", response.status);
      console.log("Response OK:", response.ok);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const result = await response.json();
      console.log("Topic Content Full Response:", result);
      
      if (result.Response === "OK" && result.data && result.data !== "FALSE") {
        console.log("✅ Topic details loaded successfully");
        
        const topicData = result.data;
        console.log("Topic Data:", topicData);
        
        // Parse JSON strings from database
        const parsedData = {
          topic_name: topicData.topic_name,
          topic_description: topicData.topic_description,
          chapter: topicData.chapter,
          sub_topic: topicData.sub_topic,
          notes: [], // Will combine topic_docs
          books: [],
          videos: [],
          presentations: []
        };
        
        // Parse topic_docs (Notes/Books)
        if (topicData.topic_docs) {
          try {
            console.log("Raw topic_docs:", topicData.topic_docs);
            console.log("Type:", typeof topicData.topic_docs);
            
            // Check if it's a direct URL or JSON
            if (topicData.topic_docs.startsWith('http')) {
              // Direct URL
              parsedData.notes = [{
                name: 'Course Material',
                url: topicData.topic_docs
              }];
              console.log("✅ topic_docs is direct URL:", parsedData.notes);
            } else {
              // Try to parse as JSON
              const docs = JSON.parse(topicData.topic_docs);
              console.log("Parsed topic_docs:", docs);
              console.log("Is Array:", Array.isArray(docs));
              
              if (Array.isArray(docs) && docs.length > 0) {
                parsedData.notes = docs.map(doc => ({
                  name: doc.name || doc.title || doc.file_name || 'Document',
                  url: doc.url || doc.link || doc.file_path || doc.path,
                  ...doc
                }));
                console.log("Mapped notes:", parsedData.notes);
              } else {
                console.log("⚠️ topic_docs is empty array or not an array");
              }
            }
          } catch (e) {
            console.error("Error parsing topic_docs:", e);
            console.error("Raw value:", topicData.topic_docs);
          }
        } else {
          console.log("⚠️ topic_docs is null/undefined");
        }
        
        // Parse topic_ppt (Presentations)
        if (topicData.topic_ppt) {
          try {
            console.log("Raw topic_ppt:", topicData.topic_ppt);
            console.log("Type:", typeof topicData.topic_ppt);
            
            // Check if it's a direct URL or JSON
            if (topicData.topic_ppt.startsWith('http')) {
              // Direct URL
              parsedData.presentations = [{
                name: 'Presentation',
                url: topicData.topic_ppt
              }];
              console.log("✅ topic_ppt is direct URL:", parsedData.presentations);
            } else {
              // Try to parse as JSON
              const ppts = JSON.parse(topicData.topic_ppt);
              console.log("Parsed topic_ppt:", ppts);
              console.log("Is Array:", Array.isArray(ppts));
              
              if (Array.isArray(ppts) && ppts.length > 0) {
                parsedData.presentations = ppts.map(ppt => ({
                  name: ppt.name || ppt.title || ppt.file_name || 'Presentation',
                  url: ppt.url || ppt.link || ppt.file_path || ppt.path,
                  ...ppt
                }));
                console.log("Mapped presentations:", parsedData.presentations);
              } else {
                console.log("⚠️ topic_ppt is empty array or not an array");
              }
            }
          } catch (e) {
            console.error("Error parsing topic_ppt:", e);
            console.error("Raw value:", topicData.topic_ppt);
          }
        } else {
          console.log("⚠️ topic_ppt is null/undefined");
        }
        
        // Parse video_links (Videos)
        if (topicData.video_links) {
          try {
            console.log("Raw video_links:", topicData.video_links);
            console.log("Type:", typeof topicData.video_links);
            
            // Check if it's a direct URL or JSON
            if (topicData.video_links.startsWith('http')) {
              // Direct URL
              parsedData.videos = [{
                name: 'Course Video',
                url: topicData.video_links,
                thumbnail: '' // Will use placeholder
              }];
              console.log("✅ video_links is direct URL:", parsedData.videos);
            } else {
              // Try to parse as JSON
              const videos = JSON.parse(topicData.video_links);
              console.log("Parsed video_links:", videos);
              console.log("Is Array:", Array.isArray(videos));
              
              if (Array.isArray(videos) && videos.length > 0) {
                parsedData.videos = videos.map(video => ({
                  name: video.name || video.title || video.video_name || 'Video',
                  url: video.url || video.link || video.video_url || video.video_link,
                  thumbnail: video.thumbnail || video.thumb || video.image,
                  ...video
                }));
                console.log("Mapped videos:", parsedData.videos);
              } else {
                console.log("⚠️ video_links is empty array or not an array");
              }
            }
          } catch (e) {
            console.error("Error parsing video_links:", e);
            console.error("Raw value:", topicData.video_links);
          }
        } else {
          console.log("⚠️ video_links is null/undefined");
        }
        
        // Parse lab_video_links (Additional Videos)
        if (topicData.lab_video_links) {
          try {
            console.log("Raw lab_video_links:", topicData.lab_video_links);
            console.log("Type:", typeof topicData.lab_video_links);
            
            // Check if it's a direct URL or JSON
            if (topicData.lab_video_links.startsWith('http')) {
              // Direct URL
              parsedData.videos.push({
                name: 'Lab Video',
                url: topicData.lab_video_links,
                thumbnail: ''
              });
              console.log("✅ lab_video_links is direct URL");
            } else {
              // Try to parse as JSON
              const labVideos = JSON.parse(topicData.lab_video_links);
              console.log("Parsed lab_video_links:", labVideos);
              console.log("Is Array:", Array.isArray(labVideos));
              
              if (Array.isArray(labVideos) && labVideos.length > 0) {
                const mappedLabVideos = labVideos.map(video => ({
                  name: video.name || video.title || video.video_name || 'Lab Video',
                  url: video.url || video.link || video.video_url || video.video_link,
                  thumbnail: video.thumbnail || video.thumb || video.image,
                  ...video
                }));
                parsedData.videos = [...parsedData.videos, ...mappedLabVideos];
                console.log("Mapped lab videos:", mappedLabVideos);
              } else {
                console.log("⚠️ lab_video_links is empty array or not an array");
              }
            }
          } catch (e) {
            console.error("Error parsing lab_video_links:", e);
            console.error("Raw value:", topicData.lab_video_links);
          }
        } else {
          console.log("⚠️ lab_video_links is null/undefined");
        }
        
        console.log("Final Parsed Data:", parsedData);
        console.log("Notes:", parsedData.notes.length);
        console.log("Books:", parsedData.books.length);
        console.log("Videos:", parsedData.videos.length);
        console.log("Presentations:", parsedData.presentations.length);
        
        setTopicDetails(parsedData);
        setView("content");
        setLoading(false);
      } else {
        console.log("❌ No content found or data is FALSE");
        alert("No content available for this topic.");
        setLoading(false);
      }
    } catch (error) {
      console.error("❌ ERROR FETCHING CONTENT:", error);
      console.error("Error name:", error.name);
      console.error("Error message:", error.message);
      
      alert("Failed to load content. Please try again.");
      setLoading(false);
    }
  };

  // Click Handlers
  const handleCourseClick = (course) => {
    console.log("Course clicked:", course);
    setSelectedCourse(course);
    fetchTopics(course.id);
  };

  const handleTopicClick = (topic) => {
    console.log("Topic clicked:", topic);
    setSelectedTopic(topic);
    fetchTopicContent(topic.id);
  };

  const handleBack = () => {
    if (view === "content") {
      setView("topics");
      setSelectedTopic(null);
      setTopicDetails(null);
    } else if (view === "topics") {
      setView("courses");
      setSelectedCourse(null);
      setTopics([]);
    }
  };

  const handleBackToCourseCard = () => {
    navigate("/CourseCard");
  };

  // Filter topics based on search
  const filteredTopics = topics.filter((topic) =>
    topic.topic_name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Get filtered content based on contentFilter
  const getFilteredContent = () => {
    console.log("=== FILTERING CONTENT ===");
    console.log("Topic Details:", topicDetails);
    console.log("Content Filter:", contentFilter);
    
    if (!topicDetails) {
      console.log("❌ No topic details available");
      return [];
    }

    let allContent = [];

    if (topicDetails.notes && (contentFilter === "All" || contentFilter === "Notes")) {
      console.log("✅ Adding Notes:", topicDetails.notes.length);
      allContent = [...allContent, ...topicDetails.notes.map(note => ({ ...note, category: "Notes" }))];
    }
    if (topicDetails.books && (contentFilter === "All" || contentFilter === "Books")) {
      console.log("✅ Adding Books:", topicDetails.books.length);
      allContent = [...allContent, ...topicDetails.books.map(book => ({ ...book, category: "Books" }))];
    }
    if (topicDetails.videos && (contentFilter === "All" || contentFilter === "Videos")) {
      console.log("✅ Adding Videos:", topicDetails.videos.length);
      allContent = [...allContent, ...topicDetails.videos.map(video => ({ ...video, category: "Videos" }))];
    }
    if (topicDetails.presentations && (contentFilter === "All" || contentFilter === "Presentations")) {
      console.log("✅ Adding Presentations:", topicDetails.presentations.length);
      allContent = [...allContent, ...topicDetails.presentations.map(ppt => ({ ...ppt, category: "Presentations" }))];
    }

    console.log("Total Content Items:", allContent.length);
    console.log("Filtered Content:", allContent);

    return allContent;
  };

  // Render content icon based on category
  const renderContentIcon = (category) => {
    switch (category) {
      case "Notes":
        return <FaFileAlt className="content-icon notes-icon" />;
      case "Books":
        return <FaBook className="content-icon books-icon" />;
      case "Videos":
        return <FaVideo className="content-icon videos-icon" />;
      case "Presentations":
        return <FaFilePowerpoint className="content-icon ppt-icon" />;
      default:
        return <FaFileAlt className="content-icon" />;
    }
  };

  // Get available partner names for debugging
  const getAvailablePartners = () => {
    return [...new Set(allCourses.map(c => c.partner_name))];
  };

  return (
    <div className="course-page">
      {/* Loading State */}
      {loading && (
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading...</p>
        </div>
      )}

      {/* Courses View */}
      {view === "courses" && !loading && (
        <section className="courses-grid-section">
          <div className="courses-container">
            {/* Back Button and Search */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '2rem' }}>
              <button 
                onClick={handleBackToCourseCard} 
                className="course-back-btn"
                style={{
                  padding: '0.5rem 1rem',
                  fontSize: '0.875rem',
                  minWidth: 'auto',
                  backgroundColor: '#ffffff',
                  border: '2px solid #1e40af',
                  borderRadius: '0.5rem',
                  color: '#1e40af',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  fontWeight: '600',
                  transition: 'all 0.2s ease'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = '#1e40af';
                  e.currentTarget.style.color = '#ffffff';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = '#ffffff';
                  e.currentTarget.style.color = '#1e40af';
                }}
              >
                <FaArrowLeft size={14} style={{ marginRight: '0.5rem' }} />
                Back
              </button>
              
              <div className="course-search-box" style={{ flex: 1, maxWidth: '400px', position: 'relative' }}>
                <FaSearch 
                  style={{
                    position: 'absolute',
                    left: '1rem',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: '#64748b',
                    width: '1.25rem',
                    height: '1.25rem'
                  }}
                />
                <input
                  type="text"
                  placeholder="Search courses..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="course-search-input"
                  style={{
                    width: '100%',
                    padding: '0.75rem 1rem 0.75rem 3rem',
                    border: '2px solid #e2e8f0',
                    borderRadius: '0.75rem',
                    fontSize: '1rem',
                    outline: 'none',
                    transition: 'all 0.3s ease'
                  }}
                  onFocus={(e) => {
                    e.currentTarget.style.borderColor = '#1e40af';
                    e.currentTarget.style.boxShadow = '0 0 0 3px rgba(30, 64, 175, 0.1)';
                  }}
                  onBlur={(e) => {
                    e.currentTarget.style.borderColor = '#e2e8f0';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                />
              </div>
            </div>

            {Object.keys(courses).length === 0 ? (
              <div className="no-data">
                <p>No courses found{categoryFilter ? ` for ${categoryFilter}` : ''}.</p>
                {getAvailablePartners().length > 0 && (
                  <div style={{ marginTop: '1.5rem', padding: '1rem', background: '#f8fafc', borderRadius: '0.75rem' }}>
                    <p style={{ fontSize: '0.9rem', color: '#64748b', marginBottom: '0.75rem', fontWeight: '600' }}>
                      📚 Available categories in your account:
                    </p>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                      {getAvailablePartners().map((partner, idx) => (
                        <span 
                          key={idx}
                          style={{ 
                            padding: '0.5rem 1rem', 
                            background: '#e0f2fe', 
                            color: '#0369a1',
                            borderRadius: '0.5rem',
                            fontSize: '0.875rem',
                            fontWeight: '600'
                          }}
                        >
                          {partner}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
                <button 
                  onClick={handleBackToCourseCard}
                  style={{
                    marginTop: '1.5rem',
                    padding: '0.75rem 1.5rem',
                    background: '#1e40af',
                    color: 'white',
                    border: 'none',
                    borderRadius: '0.5rem',
                    cursor: 'pointer',
                    fontWeight: '600',
                    fontSize: '1rem'
                  }}
                >
                  Back to Categories
                </button>
              </div>
            ) : (
              Object.keys(courses).map((partnerName) => (
                <div key={partnerName} className="partner-section">
                  <h2 className="partner-title">{partnerName.toUpperCase()}</h2>
                  <div className="courses-grid">
                    {courses[partnerName]
                      .filter(course => 
                        course.course_name?.toLowerCase().includes(searchTerm.toLowerCase())
                      )
                      .map((course) => (
                      <div
                        key={course.unique_id}
                        className="course-card"
                        onClick={() => handleCourseClick(course)}
                      >
                        <div className="course-image-container">
                          <img
                            src={course.course_image || placeholderImage(course.course_name, 300, 200)}
                            alt={course.course_name}
                            onError={imageFallback(course.course_name, 300, 200)}
                            className="course-image"
                          />
                          <div className="course-overlay">
                            <FaChevronRight className="arrow-icon" />
                          </div>
                        </div>
                        <div className="course-info">
                          <h3 className="course-title">{course.course_name}</h3>
                          <div className="progress-section">
                            <div className="progress-bar-container">
                              <div
                                className="progress-bar"
                                style={{ width: `${course.percentage}%` }}
                              ></div>
                            </div>
                            <span className="progress-text">{course.percentage}%</span>
                          </div>
                          <p className="course-stats">
                            {course.covered_topics} / {course.total_topics} Topics Completed
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))
            )}
          </div>
        </section>
      )}

      {/* Topics View */}
      {view === "topics" && !loading && (
        <section className="topics-grid-section">
          <div className="topics-container">
            {/* Header Section with Course Name */}
            <div style={{ 
              background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
              padding: '1.5rem 2rem',
              borderRadius: '1rem',
              marginBottom: '2rem',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem', justifyContent: 'space-between' }}>
                <button 
                  onClick={handleBack} 
                  className="topic-back-btn" 
                  style={{ 
                    padding: '0.625rem 1.25rem',
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    border: 'none',
                    borderRadius: '0.5rem',
                    color: '#1e40af',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    fontWeight: '600',
                    fontSize: '0.875rem',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                    transition: 'all 0.2s ease',
                    minWidth: 'fit-content'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = 'translateX(-2px)';
                    e.currentTarget.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.15)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = 'translateX(0)';
                    e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
                  }}
                >
                  <FaArrowLeft size={14} style={{ marginRight: '0.5rem' }} />
                  Back
                </button>
                
                {/* Course Name Display - Centered */}
                {selectedCourse && (
                  <div style={{ 
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '0.75rem'
                  }}>
                    <span style={{
                      fontSize: '0.875rem',
                      fontWeight: '600',
                      color: 'rgba(255, 255, 255, 0.9)',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em'
                    }}>
                      COURSE:
                    </span>
                    <span style={{ 
                      fontSize: '1.5rem', 
                      fontWeight: '700', 
                      color: '#ffffff',
                      textShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                    }}>
                      {selectedCourse.course_name}
                    </span>
                  </div>
                )}
                
                <div style={{ position: 'relative', width: '100%', maxWidth: '350px', minWidth: 'fit-content' }}>
                  <FaSearch style={{
                    position: 'absolute',
                    left: '1rem',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: '#64748b',
                    width: '1.1rem',
                    height: '1.1rem'
                  }} />
                  <input
                    type="text"
                    placeholder="Search topics..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{
                      width: '100%',
                      padding: '0.75rem 1rem 0.75rem 3rem',
                      border: 'none',
                      borderRadius: '0.75rem',
                      fontSize: '0.95rem',
                      outline: 'none',
                      backgroundColor: 'rgba(255, 255, 255, 0.95)',
                      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                      transition: 'all 0.2s ease'
                    }}
                    onFocus={(e) => {
                      e.currentTarget.style.backgroundColor = '#ffffff';
                      e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
                    }}
                    onBlur={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.95)';
                      e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
                    }}
                  />
                </div>
              </div>
            </div>
            
            <div className="topics-grid">
              {filteredTopics.map((topic, index) => (
                <div
                  key={topic.id || index}
                  className="topic-card"
                  onClick={() => handleTopicClick(topic)}
                >
                  <div className="topic-number">{index + 1}</div>
                  <div className="topic-content">
                    <h3 className="topic-title">{topic.topic_name}</h3>
                    {topic.chapter && (
                      <p className="topic-chapter">Chapter: {topic.chapter}</p>
                    )}
                    {topic.sub_topic && (
                      <p className="topic-subtitle">{topic.sub_topic}</p>
                    )}
                  </div>
                  <FaChevronRight className="topic-arrow" />
                </div>
              ))}
            </div>
            
            {filteredTopics.length === 0 && (
              <div className="no-data">
                <p>No topics found</p>
              </div>
            )}
          </div>
        </section>
      )}

      {/* Content View */}
      {view === "content" && !loading && (
        <section className="content-grid-section">
          <div className="content-container">
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '2rem', flexWrap: 'wrap' }}>
              <button 
                onClick={handleBack} 
                className="content-back-btn" 
                style={{ 
                  padding: '0.5rem 1rem',
                  backgroundColor: '#ffffff',
                  border: '2px solid #1e40af',
                  borderRadius: '0.5rem',
                  color: '#1e40af',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  fontWeight: '600',
                  fontSize: '0.875rem'
                }}
              >
                <FaArrowLeft size={14} style={{ marginRight: '0.5rem' }} />
                Back
              </button>
              <div className="content-type-filters">
                {["All", "Notes", "Books", "Videos", "Presentations"].map((filter) => (
                  <button
                    key={filter}
                    onClick={() => setContentFilter(filter)}
                    className={`category-btn ${contentFilter === filter ? "active" : ""}`}
                  >
                    {filter}
                  </button>
                ))}
              </div>
            </div>

            {topicDetails?.topic_description && (
              <div className="topic-description-card">
                <h3>Description</h3>
                <p>{topicDetails.topic_description}</p>
              </div>
            )}

            <div className="content-grid">
              {getFilteredContent().map((item, index) => (
                <div key={index} className="content-card">
                  <div className="content-header">
                    {renderContentIcon(item.category)}
                    <span className="content-category">{item.category}</span>
                  </div>
                  
                  {item.category === "Videos" && item.thumbnail && (
                    <div className="video-thumbnail-container">
                      <img 
                        src={item.thumbnail} 
                        alt={item.name}
                        className="video-thumbnail"
                      />
                      <div className="play-overlay">
                        <FaPlay className="play-icon" />
                      </div>
                    </div>
                  )}
                  
                  <div className="content-info">
                    <h4 className="content-title">{item.name}</h4>
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="content-btn"
                      onClick={(e) => e.stopPropagation()}
                    >
                      {item.category === "Videos" ? "Watch" : "Open"}
                      <FaChevronRight size={14} />
                    </a>
                  </div>
                </div>
              ))}
            </div>

            {getFilteredContent().length === 0 && (
              <div className="no-data">
                <p>No {contentFilter.toLowerCase()} available for this topic</p>
              </div>
            )}
          </div>
        </section>
      )}
    </div>
  );
};

export default CoursePage;